import { useEffect } from 'react';

import { isMacPlatform } from '../_utils/platform';

export const useGlobalSearchHotkey = (
  onToggle: () => void,
  enabled: boolean = true
) => {
  useEffect(() => {
    if (!enabled) return;

    const handler = (event: KeyboardEvent) => {
      const modifier = isMacPlatform() ? event.metaKey : event.ctrlKey;

      if (modifier && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        onToggle();
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onToggle, enabled]);
};
